import React from 'react';
import { SpinWrapper, SpinSvg } from './Spin.styled';
import { sizeMap, colorMap } from './constants';
const percentOfFill = 70;
const c = 2 * 3.14 * percentOfFill / 100;

const Spin = ({
  size,
  color = 'blue'
}) => {
  const {
    r,
    strokeWidth
  } = sizeMap[size];
  const strokeDashSize = r * c;
  const mainSize = r * 2 + strokeWidth;
  const cx = mainSize / 2;
  const cy = cx;
  const strokeColor = colorMap[color];
  return React.createElement(SpinWrapper, null, React.createElement(SpinSvg, {
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: `0 0 ${mainSize} ${mainSize}`,
    width: mainSize,
    height: mainSize
  }, React.createElement("circle", {
    strokeWidth: strokeWidth,
    cx: cx,
    cy: cy,
    r: r,
    strokeLinecap: "round",
    strokeDasharray: strokeDashSize,
    strokeDashoffset: "0",
    fill: "transparent",
    stroke: strokeColor
  })));
};

export default Spin;